import React from "react";
import Header from "../Header/Header";
import Siderbar from "../Sidebar/Siderbar";
import Footer from "../Footer/Footer";
import { PageBodyContainer, PageContainer } from "../../styledComponents";
import ContactContent from "./ContactContent/ContactContent";

const Contact = () => {
  return (
    <PageContainer>
      <Header />
      <PageBodyContainer>
        <Siderbar />
        <ContactContent />
      </PageBodyContainer>
      <Footer />
    </PageContainer>
  );
};

export default Contact;
